export var EditableGridActionTypes;
(function (EditableGridActionTypes) {
    EditableGridActionTypes["UPDATE_EDIT_ROW_DATA"] = "UPDATE_EDIT_ROW_DATA";
    EditableGridActionTypes["UPDATE_ADD_NEW_ROW_DATA"] = "UPDATE_ADD_NEW_ROW_DATA";
    EditableGridActionTypes["SET_ROW_TO_EDIT"] = "SET_ROW_TO_EDIT";
    EditableGridActionTypes["INCREMENT_INDEX_ON_EDIT"] = "INCREMENT_INDEX_ON_EDIT";
    EditableGridActionTypes["DECREMENT_INDEX_ON_EDIT"] = "DECREMENT_INDEX_ON_EDIT";
    EditableGridActionTypes["RESET_INDEX_ON_EDIT"] = "RESET_INDEX_ON_EDIT";
})(EditableGridActionTypes || (EditableGridActionTypes = {}));
